import BlBadgeAv from './BlBadgeAv.vue'

BlBadgeAv.install = function(Vue) {
  Vue.component(BlBadgeAv.name, BlBadgeAv)
}

export default BlBadgeAv
